import React from 'react';
import { SecondaryButton } from './buttons';

interface InvalidLinkComponentProps {
  message?: string;
  showContactSupport?: boolean;
}

const InvalidLinkComponent: React.FC<InvalidLinkComponentProps> = ({
  message = 'This invite link is not valid.',
  showContactSupport = true
}) => {
  return (
    <div className="min-h-screen bg-[#18181B] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-[#27272A] rounded-2xl shadow-xl p-8 text-center border border-[#3F3F46]">
        {/* Status Icon */}
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-[#EF444433] rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-[#EF4444]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-3xl font-bold text-white mb-4">
          Invalid Link
        </h1>

        {/* Error Message */}
        <div className="bg-[#EF444415] border-l-4 border-[#EF4444] rounded-2xl p-4 mb-6 text-left">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-[#EF4444]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-[#F87171]">{message}</p>
            </div>
          </div>
        </div>

        {/* Next Steps */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">What can you do?</h3>
          
          <div className="space-y-4">
            <div className="flex items-start gap-4 p-4 bg-[#3F3F46] rounded-2xl text-left border border-[#3F3F46]">
              <div className="flex-shrink-0 mt-1">
                <svg className="w-5 h-5 text-[#14B8A6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-white">Double-check the Link</h4>
                <p className="text-[#9CA3AF] text-sm">
                  Make sure you've copied the complete link from your email
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-[#3F3F46] rounded-2xl text-left border border-[#3F3F46]">
              <div className="flex-shrink-0 mt-1">
                <svg className="w-5 h-5 text-[#14B8A6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-white">Contact the Split Creator</h4>
                <p className="text-[#9CA3AF] text-sm">
                  Ask them to send you a fresh invite link
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Help Section */}
        {showContactSupport && (
          <div className="border-t border-[#3F3F46] pt-6 mb-6">
            <h4 className="font-medium text-white mb-2">Need Help?</h4>
            <p className="text-[#9CA3AF] text-sm">
              Contact support at{' '}
              <a 
                href="mailto:support@cotunemusic.com" 
                className="text-[#14B8A6] hover:text-[#0D9488] underline"
              >
                support@cotunemusic.com
              </a>
            </p>
          </div>
        )}

        {/* Action Button */}
        <SecondaryButton onClick={() => window.history.back()}>
          Go Back
        </SecondaryButton>
      </div>
    </div>
  );
};

export default InvalidLinkComponent;
